import { FC, memo } from 'react'
import { Button, Tooltip } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import { bleed } from './createPolotnoStore'

const FitImageContextMenuButton: FC = () => {
  const { store, selectedImageElement } = usePdfEditor()
  const handleFitImageClicked = useCallbackDebounced(() => {
    if (!selectedImageElement) {
      return
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (selectedImageElement?.custom?.background) {
      // minimise
      const imageIsBiggerThanCanvas =
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (selectedImageElement.custom?.naturalWidth as number) > store.activePage.computedWidth ||
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (selectedImageElement.custom?.naturalWidth as number) > store.activePage.computedHeight
      selectedImageElement.set({
        width: imageIsBiggerThanCanvas
          ? (store.activePage.computedWidth as number) * 0.5
          : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (selectedImageElement.custom?.naturalWidth as number),
        height: imageIsBiggerThanCanvas
          ? (store.activePage.computedHeight as number) * 0.5
          : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (selectedImageElement.custom?.naturalHeight as number),
        x: 50,
        y: 50,
        selectable: true,
        alwaysOnTop: false,
        showInExport: true,
        draggable: true,
        contentEditable: true,
        removable: true,
        resizable: true,
        styleEditable: true,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        custom: {
          ...selectedImageElement.custom,
          background: false,
        },
      })
      store.activePage.moveElementTop(selectedImageElement.id)
    } else {
      // maximise
      selectedImageElement.set({
        width: (store.activePage.computedWidth as number) + bleed * 2,
        height: (store.activePage.computedHeight as number) + bleed * 2,
        x: -bleed,
        y: -bleed,
        rotation: 0,
        selectable: true,
        alwaysOnTop: false,
        showInExport: true,
        draggable: false,
        contentEditable: false,
        removable: true,
        resizable: false,
        styleEditable: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        custom: {
          ...selectedImageElement.custom,
          background: true,
        },
      })
      store.activePage.moveElementBottom(selectedImageElement.id)
    }
  }, [selectedImageElement, store.activePage])
  return (
    <Tooltip
      content={
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        selectedImageElement?.custom?.background ? 'Revert to image' : 'Set as background'
      }
      placement="bottom"
    >
      <Button
        intent="none"
        variant="minimal"
        icon={
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          (selectedImageElement?.custom?.background as boolean | undefined)
            ? 'minimize'
            : 'maximize'
        }
        onClick={handleFitImageClicked}
      />
    </Tooltip>
  )
}

export default memo(FitImageContextMenuButton)
